module.exports = __webpack_public_path__ + "img/landing3.4fafa636.jpg";